/**
 * SubGroup — a nested group of filter conditions with its own AND/OR logic.
 */
import React from 'react';
import { Button } from '../ui/button';
import { Plus, X } from 'lucide-react';
import { mkCond } from './filterConstants';
import CondRow from './CondRow';

export default function SubGroup({ group, fields, onChange, onRemove }) {
  const toggleLogic = () => onChange({ ...group, logic: group.logic === 'AND' ? 'OR' : 'AND' });
  const addCond = () => onChange({ ...group, conditions: [...group.conditions, mkCond()] });
  const updCond = (i, c) => { const n = [...group.conditions]; n[i] = c; onChange({ ...group, conditions: n }); };
  const rmCond = (i) => onChange({ ...group, conditions: group.conditions.filter((_, j) => j !== i) });

  return (
    <div className="ml-4 border-l-2 border-primary/20 pl-3 py-1.5" data-testid="filter-sub-group">
      <div className="flex items-center gap-2 mb-1">
        <div className="flex rounded-md overflow-hidden border text-[9px]">
          <button onClick={toggleLogic}
            className={`px-1.5 py-0.5 font-semibold ${group.logic === 'AND' ? 'bg-primary text-primary-foreground' : 'bg-white'}`}>
            ALL
          </button>
          <button onClick={toggleLogic}
            className={`px-1.5 py-0.5 font-semibold ${group.logic === 'OR' ? 'bg-primary text-primary-foreground' : 'bg-white'}`}>
            ANY
          </button>
        </div>
        <Button size="sm" variant="ghost" onClick={addCond} className="h-5 text-[10px] px-1.5">
          <Plus className="h-3 w-3 mr-0.5" /> Add
        </Button>
        <Button size="icon" variant="ghost" onClick={onRemove} className="h-5 w-5 ml-auto text-destructive">
          <X className="h-3.5 w-3.5" />
        </Button>
      </div>
      <div className="space-y-1.5">
        {group.conditions.map((c, i) => (
          <CondRow key={c.id} cond={c} fields={fields} onChange={u => updCond(i, u)} onRemove={() => rmCond(i)} />
        ))}
      </div>
    </div>
  );
}
